import React, { useState } from "react";
import TopNav from "../../../Components/TopNav";
import Navbar from "../../../Components/Navbar";
import DropdownNav from "../../../Components/DropdownNav";
import "./about.css";
import Footer from "../../../Components/Footer";
import Example from "../../../Components/Example";
import ScrollToTop from "react-scroll-to-top";

const Measi = () => {
  const [toggle, setToggle] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [joint, setJoint] = useState(false);
  const [hons, setHons] = useState(false);
  const [princpal, setPrincpal] = useState(false);

  function updateToogle(id) {
    setToggle(id);
  }
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className="navbar-area">
        <div className="init-image">
          <div className="image-cover"></div>
        </div>
      </div>

      <div className="Measi-details">
        <div className="measi-header">
          <h2>Infrastructure → Measi</h2>
          <p>
            The New College infrastructure is one of the biggest & best in Tamil
            Nadu.
          </p>
        </div>

        <div className="tab-main">
          <ul className="tab-details">
            <li
              className={toggle === 1 ? "show-tab-title" : "tab-title"}
              onClick={() => updateToogle(1)}
            >
              Objectives
            </li>
            <li
              className={toggle === 2 ? "show-tab-title" : "tab-title"}
              onClick={() => updateToogle(2)}
            >
              Measi Down The Year
            </li>
            <li
              className={toggle === 3 ? "show-tab-title" : "tab-title"}
              onClick={() => updateToogle(3)}
            >
              Measi Institutions
            </li>
            <li
              className={toggle === 4 ? "show-tab-title" : "tab-title"}
              onClick={() => updateToogle(4)}
            >
              EC Members
            </li>
            <li
              className={toggle === 5 ? "show-tab-title" : "tab-title"}
              onClick={() => updateToogle(5)}
            >
              Measi Managing Committee
            </li>
            <li
              className={toggle === 6 ? "show-tab-title" : "tab-title"}
              onClick={() => updateToogle(6)}
            >
              Measi Office
            </li>
            {/* <li className='tab-title'>MEASI Charitable Trust</li> */}
          </ul>

          {/* Tab One Details */}

          <div className={toggle === 1 ? "show-tab-content" : "tab-content"}>
            <h1>OBJECTIVES</h1>
            <div className="tab-para">
              <p>
                ⬣ To focus on institutional functioning towards quality
                enhancement and facilitate internalization of the quality
                culture in the College.
              </p>
              <p>
                ⬣ To devise means for dissemination of higher education among
                Muslims and to promote the study of Urdu, Persian and Arabic
              </p>
              <p>
                ⬣ To arrange for imparting religious instruction side by side
                with secular education.
              </p>
              <p>
                ⬣ To help poor but intelligent and deserving students with
                scholarships, books, school – fees etc.
              </p>
              <p>
                ⬣ To impress on the minds of Muslim Public by means of lectures,
                tracks and social gatherings, the necessity of imparting western
                education to their children and Parents.
              </p>
              <p>
                ⬣ To safeguard and promote the rights and interests of the
                Muslim community in all spheres of life, viz., religious,
                educational, cultural, social and economic.
              </p>
            </div>
          </div>

          {/* Second Tab Details */}

          <div className={toggle === 2 ? "show-tab-content" : "tab-content"}>
            <h1>MEASI Down the Year</h1>
            <button
              onClick={() => setIsOpen((e) => !e)}
              className="tab-open-btn"
            >
              ✠ Presidents{" "}
            </button>
            {isOpen && (
              <div>
                <table>
                  <tr>
                    <th>S. No</th>
                    <th> Name</th>
                    <th>Year</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Hon’ble. Mr. Justice. Hunger Tudor Boddam</td>
                    <td>1902-1908</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Nawab Syed Mohammed Sahib</td>
                    <td>1908-1910</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Hon’ble. Mr. Justice. Sir Abdur Rahim</td>
                    <td>1910-1912</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Hon’ble. Mr. Justice. Faiz Badruddin Tyabji</td>
                    <td>1912-1916</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Hon’ble. Mr. Justice. Sir Abdur Rahim</td>
                    <td>1916-1920</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Sir Mohamed Habibullah Sahib</td>
                    <td>1920-1924</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Nawab C. Abdul Hakim Sahib</td>
                    <td>1924-1925</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>Sir Mohamed Usman Sahib</td>
                    <td>1925-1935</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>Janab. Haji. Jamal Mohamed Sahib</td>
                    <td>1935-1941</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>Janab. Haji. M.A. Azeem Sahib, B.A., LLB (Canada)</td>
                    <td>1941-1944</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Khan Bahadur Jawad Hussain Khan Sahib, B.A.,</td>
                    <td>1944-1945</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>Janab. Malang Ahmed Batcha Sahib, B.A.,</td>
                    <td>1945-1947</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>Janab. Haji. Moulvi. M. Nazir Husain Sahib</td>
                    <td>1947-1962</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>Janab. M.S. Abdul Majid Sahib, B.A.,</td>
                    <td>1962-1968</td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td>Janab. A.K.A. Abdul Samad Sahib, M.A., Ex. M.P.</td>
                    <td>1968-1978</td>
                  </tr>
                  <tr>
                    <td>16</td>
                    <td>
                      Janab. A.A. Rasheed Sahib, M.A., Dip. in Tech (London)
                    </td>
                    <td>1978-1982</td>
                  </tr>
                  <tr>
                    <td>17</td>
                    <td>Janab. Alhaj. T. Abdul Wahid Sahib, B.A., B.L.,</td>
                    <td>1982-1991</td>
                  </tr>
                  <tr>
                    <td>18</td>
                    <td>Janab. M. Mohamed Hashim Sahib</td>
                    <td>1991-1997</td>
                  </tr>
                  <tr>
                    <td>19</td>
                    <td>Janab. U. Mohammed Khalilullah Sahib</td>
                    <td>1997-2003</td>
                  </tr>
                  <tr>
                    <td>20</td>
                    <td>Janab. K. Ameenur Rahman Sahib</td>
                    <td>2003-2011</td>
                  </tr>
                  <tr>
                    <td>21</td>
                    <td>Janab. U. Mohammed Khalilullah Sahib</td>
                    <td>2011-2017</td>
                  </tr>
                  <tr>
                    <td>22</td>
                    <td>Nawab Mohammed Abdul Ali Azimjah</td>
                    <td>2017-2023</td>
                  </tr>
                  <tr>
                    <td>23</td>
                    <td>Janab Imthiaz Pasha Sahib</td>
                    <td>2023-</td>
                  </tr>
                </table>
              </div>
            )}

            <button
              onClick={() => setJoint((e) => !e)}
              className="tab-open-btn"
            >
              ✠ Joint HON. Secretaries{" "}
            </button>
            {joint && (
              <div>
                <table>
                  <tr>
                    <th>S. No</th>
                    <th> Name</th>
                    <th>Year</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>
                      {" "}
                      Khan Bahadur H.M.A. Hadi Badsha Sahib <br></br>
                      Janab. Haji. Mirza Hasheem Sahib Pahani <br></br>
                      Janab. Haji. Ziauddin Mohamed Sahib
                    </td>
                    <td>1902-1906</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>
                      Khan Bahadur H.M.A. Hadi Badsha Sahib <br></br>
                      Janab. Haji. Ziauddin Mohamed Sahib <br></br>
                      Khan Bahadur Mohamed Safder Hussain Sahib
                    </td>
                    <td>1906-1907</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>
                      Janab. M. Abdul Khuddus Basha Sahib <br></br>
                      Janab. Haji. Ziauddin Mohamed Sahib <br></br>
                      Janab. A. Hameed Hasan Sait Sahib
                    </td>
                    <td>1910-1912</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>
                      {" "}
                      Janab. Haji. Ziauddin Mohamed Sahib <br></br>
                      Janab. A. Hameed Hasan Sait Sahib
                    </td>
                    <td>1912-1916</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>
                      {" "}
                      Janab. A. Hameed Hasan Sait Sahib <br></br>
                      Janab. S.M.V. Osman Sahib
                    </td>
                    <td>1916-1920</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>
                      Janab. A. Hameed Hasan Sait Sahib <br></br>
                      Janab. Mir Zynuddin Sahib
                    </td>
                    <td>1920-1924</td>
                  </tr>
                </table>
              </div>
            )}

            <button onClick={() => setHons((e) => !e)} className="tab-open-btn">
              ✠ HON. Secretaries{" "}
            </button>
            {hons && (
              <div>
                <table>
                  <tr>
                    <th>S. No</th>
                    <th> Name</th>
                    <th>Year</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Janab. Mir Zynuddin Sahib</td>
                    <td>1919-1924</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Janab. A. Hameed Hasan Sait Sahib</td>
                    <td>1924-1927</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>Janab. Haji. M.A. Azeem Sahib, B.A., LLB (Cantab)</td>
                    <td>1927-1933</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Janab. Mohamed Hasan Chida Sahib</td>
                    <td>1933-1935</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>Dr. Hamid Ali Sahib</td>
                    <td>1935-1936</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Janab. Malang Ahmed Batcha Sahib, B.A.,</td>
                    <td>1936-1945</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>Janab. Basheer Ahmed Sayeed Sahib, M.A., B.L.,</td>
                    <td>1945-1949</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>Janab. M.S. Abdul Majid Sahib, B.A.,</td>
                    <td>1949-1962</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>Janab. B. Abdul Gadir</td>
                    <td>1962-1965</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>
                      Janab. A.A. Rasheed Sahib, M.A., Dip. in Tech (London)
                    </td>
                    <td>1965-1978</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Janab. A.J. Abdul Razak Sahib, B.A., B.L.,</td>
                    <td>1978-1988</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td>Janab. K.V.M. Abdul Kareem Sahib</td>
                    <td>1988-1991</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td>Janab. U. Mohamed Khalilullah Sahib</td>
                    <td> 1991-1997</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>Janab. S.C.M. Jamaldeen Sahib</td>
                    <td>1997-2003</td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td>Janab. H.M. Shamsudeen Sahib</td>
                    <td>2003-2011</td>
                  </tr>
                  <tr>
                    <td>16</td>
                    <td>Janab. A. Mohammed Ashraf Sahib</td>
                    <td>2011-2017</td>
                  </tr>
                  <tr>
                    <td>17</td>
                    <td> Janab. T. Rafeeq Ahmed Sahib</td>
                    <td>2017-2020</td>
                  </tr>
                  <tr>
                    <td>18</td>
                    <td>Janab. Elias Sait</td>
                    <td>2020-</td>
                  </tr>
                </table>
              </div>
            )}

            <button
              onClick={() => setPrincpal((e) => !e)}
              className="tab-open-btn"
            >
              ✠ Principal Down the Year{" "}
            </button>
            {princpal && (
              <div>
                <table>
                  <tr>
                    <th>S. No</th>
                    <th> Name</th>
                    <th>Year</th>
                  </tr>
                  <tr>
                    <td>1</td>
                    <td>Prof. J. Franco, M.A., L.T., O.B.E.,</td>
                    <td>1951-1956</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td> Prof. V. Thiruvenkatacharya, M.A., L.T.,</td>
                    <td>1956-1958</td>
                  </tr>
                  <tr>
                    <td>3</td>
                    <td>
                      Prof. Alhaj. Afzal-Ul-Ulema <br></br>
                      Syed Abdul Wahab Bukhari Sahib, M.A., L.T.,
                    </td>
                    <td>1958-1967</td>
                  </tr>
                  <tr>
                    <td>4</td>
                    <td>Prof. A. Gopalakrishna, M.A.,</td>
                    <td>1967-1969</td>
                  </tr>
                  <tr>
                    <td>5</td>
                    <td>
                      {" "}
                      Dr. H. Mohamed Mohideen, M.A., Ph.D., F.A.Z., D.H.Ed.,
                    </td>
                    <td>1969-1981</td>
                  </tr>
                  <tr>
                    <td>6</td>
                    <td>Prof. T. Md. Dawood Khan, M.A., M.Com.,</td>
                    <td>1981-1987</td>
                  </tr>
                  <tr>
                    <td>7</td>
                    <td>
                      Dr. H. Mohamed Mohideen, M.A., Ph.D., F.A.Z., D.H.Ed.,
                    </td>
                    <td>1987-1989</td>
                  </tr>
                  <tr>
                    <td>8</td>
                    <td>Prof. G. Mohamed Farhathullah, M.Sc.,</td>
                    <td>1989-1994</td>
                  </tr>
                  <tr>
                    <td>9</td>
                    <td>
                      {" "}
                      Dr. Major. M. Jailani, M.Sc., M.A., M.Phil., Ph.D.,
                    </td>
                    <td>1962-1965</td>
                  </tr>
                  <tr>
                    <td>10</td>
                    <td>Prof. N. Ahmed Basha, M.A., M.Litt.,</td>
                    <td>2000-2001</td>
                  </tr>
                  <tr>
                    <td>11</td>
                    <td>Prof. Mir Hadi Ali, M.A., M.Phil.,</td>
                    <td>2001-2002</td>
                  </tr>
                  <tr>
                    <td>12</td>
                    <td> Prof. Avaram Abdul Hakeem, M.Sc., M.Phil.,</td>
                    <td>2002-2005</td>
                  </tr>
                  <tr>
                    <td>13</td>
                    <td> Prof. A. Kadar Basha, M.A., M.Phil., M.B.A.,</td>
                    <td>2005-2008</td>
                  </tr>
                  <tr>
                    <td>14</td>
                    <td>Dr. K. Altaff, M.Sc., M.Phil., Ph.D.,</td>
                    <td>2008-2012</td>
                  </tr>
                  <tr>
                    <td>15</td>
                    <td>Dr. S. Abdul Maliq, M.A., M.Phil., Ph.D.,</td>
                    <td> 2012-2016</td>
                  </tr>
                  <tr>
                    <td>16</td>
                    <td>Dr. Major. Zahid Husain, M.A., M.Phil., Ph.D.,</td>
                    <td>2016-2018</td>
                  </tr>
                  <tr>
                    <td>17</td>
                    <td>Dr. A. Abdul Jabbar, M.Sc., M.Phil., Ph.D.,</td>
                    <td>2018-2020</td>
                  </tr>
                  <tr>
                    <td>18</td>
                    <td>
                      {" "}
                      Dr. S. Basheer Ahamed, M.A., M.Phil., B.Ed., Ph.D.,
                    </td>
                    <td>2020-2023</td>
                  </tr>
                  <tr>
                    <td>18</td>
                    <td> Dr. M. Asrar Sheriff, M.Sc., M.Phil., Ph.D.,</td>
                    <td>2023-</td>
                  </tr>
                </table>
              </div>
            )}
          </div>

          {/* Third Tab Details */}

          <div className={toggle === 3 ? "show-tab-content" : "tab-content"}>
            <h1>MEASI Institutions</h1>
            <div className="tab-para">
              <p>⬣ THE NEW COLLEGE</p>
              <p>⬣ MEASI INSTITUTE OF MANAGEMENT</p>
              <p>⬣ MEASI ACADEMY OF ARCHITECTURE</p>
              <p>⬣ MEASI INSTITUTE OF INFORMATION TECHNOLOGY</p>
              <p>⬣ MEASI COLLEGE OF EDUCATION</p>
              <p>⬣ MEASI MATRICULATION HR SEC SCHOOL</p>
              <p>⬣ MEASI URDU ACADEMY</p>
              <p>⬣ MEASI C.A ACADEMY</p>
            </div>
          </div>

          {/* Fourth Tab Details */}

          <div className={toggle === 4 ? "show-tab-content" : "tab-content"}>
            <h1>
              MEMBERS OF THE EXECUTIVE COMMITTEE FOR THE YEAR <br></br>{" "}
              2023–2024
            </h1>
            <div className="fourth-tab-para">
              <div>
                <p>⬣ JANAB A. MOHAMED ASHRAF SAHIB</p>
                <p>⬣ JANAB K.M. AASIM SHEHZAD SAHIB</p>
                <p>⬣ JANAB M. ABDUL WAHAB SAHIB</p>
                <p>⬣ JANAB P. MOHAMED YOUSUF SAHIB</p>
                <p>⬣ JANAB C. ABDUL WAHAB SAHIB</p>
                <p>⬣ JANAB C. ABDUL WAHAB SAHIB</p>
                <p>⬣ JANAB K.N. BASHA SAHIB</p>
                <p>⬣ JANAB RIAZ RAZZACK SAHIB</p>
                <p>⬣ JANAB A. ALTHAF HUSSAIN SAHIB</p>
                <p>⬣ JANAB HUSSAIN IQBAL SHAH SAHIB</p>
                <p>⬣ JANAB W.S. HABIB</p>
                <p>⬣ JANAB T. ADNAN AHMED SAHIB</p>
                <p>⬣ JANAB S. SALAHUDEEN SAHIB</p>
                <p>⬣ JANAB MANDI MOHAMED HAMMAD SAHIB</p>
                <p>⬣ JANAB PROF. P.M.S. ABDUL GAFFOOR SAHIB</p>
                <p>⬣ JANAB H. MUJEEBUR RAHMAN SAHIB</p>
                <p>⬣ JANAB SYED TARIQ AHMED SAHIB</p>
                <p>⬣ JANAB M.M.K. MOHIDEEN IBRAHIM SAHIB</p>
                <p>⬣ JANAB K.E.M. THAMEEM ANSARI SAHIB</p>
                <p>⬣ JANAB MOHAMMED FAYAZ ALI SAHIB</p>
                <p>⬣ JANAB THAIKA MOHAMED ASHRAF SAHIB</p>
                <p>⬣ JANAB MECCA RAFEEQ AHMED SAHIB</p>
                <p>⬣ JANAB M. AVAIS MUSVEE SAHIB</p>
                <p>⬣ JANAB DR. JUNAID RASHEED SAHIB</p>
                <p>⬣ JANAB P.R. AQEEL AHMED SAHIB</p>
                <p>⬣ JANAB Y.J. SHABBIR SAHIB</p>
                <p>⬣ JANAB J. ANVER SALMAN SAHIB</p>
                <p>⬣ JANAB F. ARIF NAWAZ SAHIB</p>
                <p>⬣ JANAB KAKA ANEES AHMED SAHIB</p>
                <p>⬣ JANAB H.M. SHAMSUDEEN SAHIB</p>
                <p>⬣ JANAB N.D.S. SATHAK ANSARI SAHIB</p>
              </div>

              <div className="right-tab-para">
                <p>⬣ JANAB S.Z. ABRAR AHMED SAHIB</p>
                <p>⬣ JANAB A. AHMED IBRAHIM SAHIB</p>
                <p>⬣ JANAB E.S.M. FAIZEL B. ABDUL CADER SAHIB</p>
                <p>⬣ JANAB K. ANEES AHMED SAHIB</p>
                <p>⬣ JANAB A. UVAIS AHMED SAHIB</p>
                <p>⬣ JANAB M. MOHAMED NAZAR SAHIB</p>
                <p>⬣ JANAB IMRAN PASHA SAHIB</p>
                <p>⬣ JANAB M. MOHAMED SHARFUDDIN SAHIB</p>
                <p>⬣ JANAB MOHAMED SATHAK SAHIB</p>
                <p>⬣ JANAB AZEEZUR RAHMAN SHARIFF SAHIB</p>
                <p>⬣ JANAB H.E. ABDUL AZEEZ SAHIB</p>
                <p>⬣ JANAB G.S.K. MASUD SAHIB</p>
                <p>⬣ JANAB H. MAHMOOD AKTHAR SAHIB</p>
                <p>⬣ JANAB S. MOHAMED YOOSUF SAHIB</p>
                <p>⬣ JANAB S.M. HABIB MD. SATHAKATHULLAH SAHIB</p>
                <p>⬣ NAWABZADA MOHAMMED ASIF ALI SAHIB</p>
                <p>⬣ JANAB MOHAMED RUHULLAH SAHIB</p>
                <p>⬣ JANAB ZAFARULLAH KHAN SAHIB</p>
                <p>⬣ JANAB ABDUL JABBAR SUHAIL SAHIB</p>
                <p>⬣ JANAB M.A. MOHAMED YOUSUF SAHIB</p>
                <p>⬣ JANAB S.M.Y. ASLAM HUSSAIN SAHIB</p>
                <p>⬣ JANAB SHABREZ SHOUKATH SAHIB</p>
                <p>⬣ JANAB T. MOHAMED MUBEEN SAHIB</p>
                <p>⬣ JANAB A. H. LAFIR SAHIB</p>
                <p>⬣ JANAB S.M. ABDUR RAHEEM PATEL SAHIB</p>
                <p>⬣ JANAB S.M. SHAHJAHAN SAHIB</p>
                <p>⬣ JANAB B.S.A. ABDUL QADIR SAHIB</p>
                <p>⬣ JANAB C. KHAISER AHMED SAHIB</p>
                <p>⬣ JANAB J. MOHAMED AMEEN SAHIB</p>
                <p>⬣ JANAB H. PEER MOHAMED SAHIB</p>
                <p>⬣ JANAB P. MOHAMED YOUSUF SAHIB</p>
              </div>
            </div>
          </div>

          {/* Fifth Tab Details */}

          <div className={toggle === 5 ? "show-tab-content" : "tab-content"}>
            <h1>MEASI Managing Committee</h1>
            <h2>
              OFFICE BEARERS OF THE ASSOCIATION FOR THE YEAR <br></br> 2023-2024
            </h2>
            <div className="fourth-tab-para">
              <div>
                <h3>IMMEDIATE PAST PRESIDENT</h3>
                <p>⬣ His Highness Nawab Mohamed Abdul Ali Azimjah</p>
                <br></br>
                <br></br>
                <h3>PATRONS</h3>
                <p>⬣ Janab M. Mohamed Hashim Sahib</p>
                <p>⬣ Janab U. Mohamed Khalilullah Sahib</p>
                <br></br>
                <br></br>
                <h3>CHAIRMAN</h3>
                <p>⬣ Janab. Imthiaz Pasha</p>
                <br></br>
                <br></br>
                <h3>HON. SECRETARY & CORRESPONDENT</h3>
                <p>⬣ Janab Elias Sait Sahibb</p>
                <br></br>
                <br></br>
                <h3>HON. TREASURER</h3>
                <p> ⬣ Janab. S.M.A. Mohammed Saleem</p>
                <br></br>
                <br></br>
              </div>

              <div className="right-tab-para">
                <h3>HON. ASSISTANT SECRETARIES</h3>
                <p> ⬣ Janab A. Imtiaz Ahmed</p>
                <p> ⬣ Janab S.K. Nawaz</p>
                <p> ⬣ Janab M. Nazar Mohamed</p>
                <p> ⬣ Janab M. Muniruddin Sheriff</p>
                <p> ⬣ Janab S.K. Sham Shahabudeen</p>
                <p> ⬣ Janab Ashfaque Ahmed Mecca</p>
                <br></br>
                <br></br>
                <h3>HON. ASSISTANT TREASURER:</h3>
                <p> ⬣ Janab Sajid Sathak</p>
                <br></br>
                <br></br>
                <h3>MEMBERS:</h3>
                <p> ⬣ Janab M. Razzack</p>
                <p> ⬣ Janab A. Mohamed Ashraf</p>
                <p> ⬣ Janab H.M. Shamsudeen</p>
                <p> ⬣ Janab Abdul Jabbar Suhail</p>
                <p> ⬣ Janab. J. Anver Salman</p>
                <p> ⬣ Dr. M. Asrar Sheriﬀ - Principal (Ex-oﬃcio)</p>
                <br></br>
                <br></br>
              </div>
            </div>
          </div>

          {/* Sixth Tab Details */}

          <div className={toggle === 6 ? "show-tab-content" : "tab-content"}>
            <h1>MEASI OFFICE</h1>
            <div className="fourth-tab-para">
              <div>
                <h3>EXECUTIVE DIRECTOR</h3>
                <p>⬣ N. ISHTIAQ AHMED</p>
                <br></br>
                <br></br>
                <h3>MANAGER</h3>
                <p>⬣ MOHAMED FAZLULLAH</p>
                <br></br>
                <br></br>
                <h3>ACCOUNTANT</h3>
                <p>⬣ K. SAMEEULLAH</p>
                <br></br>
                <br></br>
                <h3>CLERK</h3>
                <p>⬣ B. HUSSAIN</p>
                <br></br>
                <br></br>
                <h3>MANAGEMENT TRAINEE</h3>
                <p> ⬣ A. MOHAMED JAVID</p>
                <br></br>
                <br></br>
              </div>

              <div className="right-tab-para">
                <h3>MANAGEMENT TRAINEE</h3>
                <p> ⬣ G. SHAFEEQ AHMED</p>
                <br></br>
                <br></br>
                <h3>ATTENDER</h3>
                <p> ⬣ S.M. MOHIDEEN MASTAN</p>
                <br></br>
                <br></br>
                <h3>MAINTENANCE ENGINEER</h3>
                <p> ⬣ CHELLAPANDIAN SUBBAIAH</p>
                <br></br>
                <br></br>
                <h3>ESTATE OFFICE</h3>
                <p> ⬣ M. A. MOHAMED MOHIDEEN</p>
                <br></br>
                <br></br>
                <h3>OFFICE ASSISTANT</h3>
                <p> ⬣ N. NOOR MOHAMED</p>
                <br></br>
                <br></br>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Measi;
